import React from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import CuteMixer from './containers/CuteMixer/CuteMixer';
// import classes from './App.css';
// import Financing from './containers/Financing/Financing';
import Home from './containers/Home';
import PixelMixer from './containers/PixelMixer/PixelMixer';
import Layout from './hoc/Layout';

export const PATHNAMES = {
  HOME: '/',
  // FINANCING: '/financing',
  PIXELMIXER: '/overwatchpixelmixer',
  // TOPTENPIXEL: '/toptenpixel',
  // TOPTENCUTE: '/toptencute',
  CUTEMIXER: '/overwatchcutemixer',
};

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        {/*<Route path="/pharmercybird" element={<Pharmercybird />}/>*/}
        {/* <Route path={PATHNAMES.FINANCING} element={<Financing />} /> */}
        <Route path={PATHNAMES.PIXELMIXER} element={<PixelMixer />} />
        {/* <Route path={PATHNAMES.TOPTENCUTE} element={<TopCute />} /> */}
        {/* <Route path={PATHNAMES.TOPTENPIXEL} element={<TopPixel />} /> */}
        <Route path={PATHNAMES.CUTEMIXER} element={<CuteMixer />} />
        <Route path={PATHNAMES.HOME} element={<Home />} />
      </Route>
    </Routes>
  );
}

export default App;
